import { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const UpdateEmergencyContactLazy = lazyLoader(
  () =>
    import(
      './UpdateEmergencyContact' /* webpackChunkName: "update-emergency-contact" */
    ),
);

const UpdateEmergencyContact = () => {
  return (
    <Suspense fallback={null}>
      <UpdateEmergencyContactLazy />
    </Suspense>
  );
};

export default UpdateEmergencyContact;
